import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import img from '../components/images/nike.png';
import Button from './Button';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { getCartItemsCount } = useCart();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const cartItemsCount = getCartItemsCount();

  return (
    <div className="header-container fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="flex justify-between items-center p-4">
        {/* Logo Section */}

        <a href="/" className="inline-block">
          <img
            src={img}
            className="w-[50px] md:w-[80px]"
            alt="Logo"
          />
        </a>


        {/* Center Navigation Links (Visible in Both Desktop and Mobile) */}
        <div className="flex gap-5 absolute left-1/2 transform -translate-x-1/2 md:hidden">

          <Link to="/" className="text-black text-sm">Home</Link>
          <Link to="/store" className="text-black text-sm">Store</Link>
          <Link to="/contact" className="text-black text-sm">Contact</Link>
        </div>

        {/* Center Navigation Links (Desktop Only) */}
        <div className="hidden md:flex gap-5 absolute left-1/2 transform -translate-x-1/2 mr-10">
          <Link to="/" className="text-black text-sm md:text-base">Home</Link>
          <Link to="/store" className="text-black text-sm md:text-base">Store</Link>
          <Link to="/contact" className="text-black text-sm md:text-base">Contact</Link>
        </div>

        {/* Cart and Login (Desktop Only) */}
        <div className="hidden md:flex items-center gap-4 mr-5">
          <Link to="/cart" className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            {cartItemsCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-black text-white text-xs rounded-full h-5 w-5 flex items-center justify-center text-center leading-none">
                {cartItemsCount > 99 ? '99+' : cartItemsCount}
              </span>
            )}
          </Link>
          <Button onCloseMenu={() => setMenuOpen(false)} />
        </div>

        {/* Mobile Hamburger Menu */}
        <div className="md:hidden flex items-center">
          <StyledWrapper>
            <label className="hamburger">
              <input
                type="checkbox"
                checked={menuOpen}
                onChange={toggleMenu}
              />
              <svg viewBox="0 0 32 32">
                <path
                  className="line line-top-bottom"
                  d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
                />
                <path className="line" d="M7 16 27 16" />
              </svg>
            </label>
          </StyledWrapper>
        </div>
      </div>

      {/* Mobile Menu Options */}
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-center py-4 z-40">
          <nav className="w-full flex flex-col items-center gap-4">
            <Link to="/cart" className="text-black text-sm py-2 flex items-center gap-2">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              Cart {cartItemsCount > 0 && `(${cartItemsCount})`}
            </Link>
            <div className="mt-4">
              <Button onCloseMenu={() => setMenuOpen(false)} />
            </div>
          </nav>
        </div>
      )}
    </div>
  );
};

const StyledWrapper = styled.div`
  .hamburger {
    cursor: pointer;
  }

  .hamburger input {
    display: none;
  }

  .hamburger svg {
    height: 1.5em;
    transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line {
    fill: none;
    stroke: black;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3;
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
      stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line-top-bottom {
    stroke-dasharray: 12 63;
  }

  .hamburger input:checked + svg {
    transform: rotate(-45deg);
  }

  .hamburger input:checked + svg .line-top-bottom {
    stroke-dasharray: 20 300;
    stroke-dashoffset: -32.42;
  }
`;

export default Header;
